import { render, staticRenderFns } from "./CreatePollChatModal.vue?vue&type=template&id=5dd0cff3"
import script from "./CreatePollChatModal.vue?vue&type=script&lang=js"
export * from "./CreatePollChatModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePollChatModal.vue?vue&type=style&index=0&id=5dd0cff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports